import { Controller } from "@hotwired/stimulus"

// 결제 상태 관리 컨트롤러
export default class extends Controller {
  static targets = ["successMessage"]

  connect() {
    console.log("Payment status controller connected")
    
    // 결제 완료 메시지 애니메이션 효과 제거 (3초 후)
    setTimeout(() => {
      if (this.hasSuccessMessageTarget) {
        this.successMessageTarget.classList.remove("animate-pulse")
      }
    }, 3000)
    
    // 결제 상태 자동 업데이트 (5초마다)
    this.startStatusRefresh()
  }
  
  disconnect() {
    // 타이머 정리
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }
  
  startStatusRefresh() {
    // Turbo Frame의 자동 리프레시 기능 사용
    const turboFrame = this.element.querySelector('turbo-frame[id*="payment_status"]')
    const paymentId = this.element.dataset.paymentId
    
    if (turboFrame && paymentId) {
      // Turbo Frame에 자동 리프레시 설정
      turboFrame.src = `/payments/${paymentId}/status`
      
      // 5초마다 리로드 (Turbo Frame 기본 기능 활용)
      this.refreshTimer = setInterval(() => {
        turboFrame.reload()
      }, 5000)
    }
  }
}
